import style from "./LisencePlate.module.css";
import classNames from "classnames/bind";
import Table from "./Table";
import { useContext, useEffect, useState } from "react";
import Filter from "../Filter/Filter";
import { LisencePlateManagerContext } from "../../../../contexts";
import { Toast } from "../../../../components";
import { formatDB, formatDate } from "../../../../utils";
import axiosClient from "../../../../services/axiosClient";

const cx =classNames.bind(style);

const LicensePlate = () => {
    const { cameraCode, setTimeStart, setTimeEnd, dataStore, nameService, timeEnd, timeStart, params, isShow } = useContext(LisencePlateManagerContext)
    const [pages, setPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [hourStart, setHourStart] = useState();
    const [hourEnd, setHourEnd] = useState();
    const [isFilterHour, setIsFilterHour] = useState(true);
    const [data, setData] = useState([]);
    const [dayHl,setDayHl] = useState([])
    let start = new Date(timeStart);
    let end = new Date(timeEnd)
    const onChangeTimeStart = (data) => {
        let dataStart = new Date(data)
        if (dataStart <= end) {
            setTimeStart(data);
            setCurrentPage(1);
        } else {
            Toast.open('Thời gian chọn không phù hợp', 'danger')
        }
    };
    const onChangeTimeEnd = (data) => {
        let dataEnd = new Date(data);
        if (dataEnd >= start) {
            setTimeEnd(data);
            setCurrentPage(1);
        } else {
            Toast.open('Thời gian chọn không phù hợp', 'danger')
        }
    };
    const handleOke = (start, end) => {
        let startD = new Date(start);
        let endD = new Date(end);
        if (startD < endD) {
            setIsFilterHour(true)
            setHourEnd(end)
            setHourStart(start)
            setCurrentPage(1)
        } else {
            Toast.open('Thời gian kết thúc không được nhỏ hơn thời gian bắt đầu', 'danger')
        }
    }

    useEffect(() => {
        let date = new Date();
        if (dataStore.pathNotification.time) {
            date = dataStore.pathNotification.time;
            const time = formatDate(date)
            setTimeStart(time);
            setTimeEnd(time);
        } else if (!timeEnd || !timeStart) {
            const time = formatDate(date)
            setTimeStart(time);
            setTimeEnd(time);
        }
    }, [dataStore.pathNotification.time])

    useEffect(() => {
        async function getListPlayBack() {
            const day =
                timeStart && timeEnd
                    ? {
                        day_start: formatDB(timeStart),
                        day_end: formatDB(timeEnd),
                    }
                    : {};
            const time = isFilterHour && hourEnd && hourStart ? {
                hour_start: `${hourStart}:00`,
                hour_end: `${hourEnd}:00`,
            } : {}
            if (cameraCode && day.day_end) {
                const res = await axiosClient.get("/camALPR/get-list-cam-license-plate/", {
                    params: {
                        camera_code: cameraCode,
                        // ...day,
                        // ...time,
                        page: currentPage,
                        size: 10,
                    },
                });
                
                if (res) {
                    const day = res.AI_day.map(item=>item.TIME)
                    setDayHl(day)
                    const total = Math.ceil(res.count / 10);
                    if (total < currentPage) {
                        setCurrentPage(1)
                    } else {
                        setPages(total)
                    }
                    setData(res.data);
                }
            }
        }
        getListPlayBack();
    }, [cameraCode, timeEnd, timeStart, hourStart, hourEnd, isFilterHour, currentPage, params.id]);
    return (
        <div className={cx("data")}>
            <div id="__notification"></div>
            <div className={cx("filter")}>
                <Filter
                    onChangeDayEnd={onChangeTimeEnd}
                    onChangeDayStart={onChangeTimeStart}
                    timeStart={timeStart}
                    timeEnd={timeEnd}
                    isFilter={isFilterHour}
                    onOk={handleOke}
                    dayHl={dayHl}
                    
                />
            </div>
            <Table data={data} getPage={data => setCurrentPage(data)} pages={pages} currentPage={currentPage} />

        </div>
    )
}

export default LicensePlate;